export const generateMonthsFromIssue = (startIssue, count = 12) => {
  if (!startIssue) return [];

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const match = startIssue.match(/^([A-Za-z]{3})(\d{2})$/);
  if (!match) return [];

  const [, monthStr, yearStr] = match;
  const startMonthIndex = monthNames.indexOf(monthStr);
  if (startMonthIndex === -1) return [];

  const startYear = parseInt(yearStr, 10);
  const months = [];

  for (let i = 0; i < count; i++) {
    const currentMonthIndex = (startMonthIndex + i) % 12;
    const currentYear = startYear + Math.floor((startMonthIndex + i) / 12);
    const monthName = `${monthNames[currentMonthIndex]}${currentYear.toString().padStart(2, '0')}`;

    months.push({
      month: monthName,
      isSelected: i === 0,
      artworkNote: '',
      filename: '',
    });
  }

  return months;
};

export const formatMonthForDisplay = month => {
  if (!month) return '';
  const match = month.match(/^([A-Za-z]{3})(\d{2})$/);
  if (!match) return month;

  const [, monthStr, yearStr] = match;
  return `${monthStr}${yearStr}`;
};

export const getSelectedMonths = (monthlyArtwork = []) => {
  return monthlyArtwork.filter(item => item.isSelected).map(item => item.month);
};

export const getLatestSelectedMonth = (monthlyArtwork = []) => {
  const selectedMonths = monthlyArtwork.filter(item => item.isSelected);

  if (selectedMonths.length === 0) {
    return null;
  }

  const lastSelectedIndex = Math.max(
    ...selectedMonths.map(item => monthlyArtwork.findIndex(m => m.month === item.month))
  );

  return monthlyArtwork[lastSelectedIndex]?.month || null;
};
